import React, { Component } from "react";
import { arrayOf, bool, element, string } from "prop-types";

class Fieldset extends Component {
  static propTypes = {
    children: arrayOf(element).isRequired,
    title: string.isRequired,
    isRequired: bool,
  };

  render() {
    const { children, title, isRequired = false } = this.props;

    return (
      <div className="fieldset">
        <div className="fieldset__title">
          <h3>{title}{isRequired ? '*' : ''}</h3>
          <div className="border" />
        </div>
        <div className="fieldset__content">
          <div className="border" />
          {children}
        </div>
      </div>
    );
  }
}

export default Fieldset;
